<template>
  <div v-if="isShow" class="fixed-wrapper" @click.self="$emit('close')">
    <div class="k-modal-window" :style="modalWindowStyle">
      <div style="width: 100%; overflow-y: auto;">
        <div class="loading-indication" v-if="loading">
          <k-spinner />
        </div>
        <go-back @click="$emit('close')" :text="backText" mini/>
        <div class="k-modal-window__wrapper">
          <slot></slot>
        </div>
      </div>
      </div>
  </div>
</template>

<script>
import GoBack from "../components/TheGoBack";
import KSpinner from '../components/TheSpinner';

export default {
  name: "ModalDialog",
  components: {
    GoBack,
    KSpinner,
  },
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    verticalCenter: {
      type: Boolean,
      required: false,
      default: true
    },
    backText: {
      type: String,
      required: false,
      default: 'Назад к поиску'
    },
  },
  computed: {
    modalWindowStyle() {
      return {
        justifyContent: this.verticalCenter ? undefined : 'start'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fixed-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.15);
  z-index: 10;

  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 60px;
}

.k-modal-window {
  width: 100%;
  height: 100%;
  max-width: 1090px;
  /* max-height: 596px; */

  /* overflow-y: auto; */

  background: #ffffff;
  border: 1px solid #ebebeb;
  box-sizing: border-box;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.05);
  border-radius: 2px;
  padding: 40px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  position: relative;
}

.k-modal-window__arrow {
  min-width: 40px;
  min-height: 40px;
  border-radius: 50%;
  background: #f7981e;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  &.disabled {
    background: #cfd2d3;
    pointer-events: none;
  }
}

.k-modal-window__wrapper {
  width: 100%;
  /*height: 100%;*/
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.k-modal-steps {
  width: 100%;
  display: flex;
}
.k-modal-steps__step {
  min-width: 26px;
  min-height: 26px;
  border-radius: 50%;
  background: #e4e4e4;
  position: relative;
  transition: all 0.25s linear;

  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 65%;
    height: 65%;
    background: #fff;
    border-radius: 50%;
  }

  &.active {
    background: #fff;

    &::after {
      background: #f7981e;
      width: 45%;
      height: 45%;
    }
  }

  &.skip {
    background: #f7981e;

    &::after {
      content: unset;
    }
  }
}
.k-modal-steps__linker {
  height: 2px;
  background: #e4e4e4;
  width: 100%;
}

@media (max-width: 767.98px) {
  .k-modal-window {
    padding: 10px !important;
    justify-content: center;
    max-height: 100%;
  }
  .k-modal-window__arrow {
    display: none;
  }
  .k-modal-go-back {
    display: block;
    height: 50px;
    padding-top: 10px;
  }
}
</style>
